"use client";

import { c as _c } from "react/compiler-runtime";
import { useChatContext } from "./chat-provider";
import { cn } from "@/lib/utils";
export function ChatSessionTabs() {
  const $ = _c(9);
  const {
    visitorSessions,
    activeSessionId,
    setActiveSessionId
  } = useChatContext();
  let t0;
  if ($[0] !== activeSessionId || $[1] !== setActiveSessionId || $[2] !== visitorSessions) {
    let t1;
    if ($[4] !== activeSessionId || $[5] !== setActiveSessionId) {
      t1 = vs => <button key={vs.visitorSessionId} onClick={() => setActiveSessionId(vs.visitorSessionId)} className={cn("shrink-0 whitespace-nowrap px-3 py-2 text-xs transition-colors", activeSessionId === vs.visitorSessionId ? "border-b-2 border-accent font-medium text-accent" : "text-muted-foreground hover:text-foreground")}>{vs.sessionTitle}</button>;
      $[4] = activeSessionId;
      $[5] = setActiveSessionId;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    t0 = visitorSessions.map(t1);
    $[0] = activeSessionId;
    $[1] = setActiveSessionId;
    $[2] = visitorSessions;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[7] !== t0) {
    t1 = <div className="flex overflow-x-auto border-b bg-background">{t0}</div>;
    $[7] = t0;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}